





























import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    BaseButton
  }
})
export default class DisableCourseModulesModal extends Vue {
  @Prop({ type: Number, default: 0 }) readonly activeCourseModuleCount!: number;

  @Emit('close')
  closeModal() {
    return;
  }

  @Emit('confirmDelete')
  handleConfirmDelete() {
    return;
  }
}
